/* basert på http://plnkr.co/edit/YHsxmmLzayOt5DLo2LCG?p=preview */
import {IDirective, INgModelController, IScope} from "angular";

export function erLikFeltForInjisering() {
    return [erLikFelt]
}

/** Matcher to felter mot hverandre, f.eks. for å bekrefte passord */
export function erLikFelt(): IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: ($scope: IScope, $elem, $attrs: any, ctrl: INgModelController) => {

            var valider = (feltverdi) => {
                var sammenlignMed = $attrs.erLikFelt;
                if (!feltverdi || !sammenlignMed) {
                    ctrl.$setValidity("erLikFelt", true); // har ikke noe å sammenligne med
                }

                ctrl.$setValidity("erLikFelt", feltverdi === sammenlignMed);
                return feltverdi;
            };

            ctrl.$parsers.unshift(valider);
            ctrl.$formatters.push(valider);

            $attrs.$observe('erLIkFelt', (sammenlignMedModell) => {
                return valider(sammenlignMedModell.$viewValue);
            })
        }
    }
}
